import React from "react";
import { Carousel, CarouselItem } from "react-bootstrap";
import rio from "../Images/rio.jpg";
import kayak from "../Images/kayak.jpg";
import barco from "../Images/barco.jpg";
import dron1 from "../Images/dron1.jpeg";
import CarouselImage from "./CarouselImage";

const CarouselComponent = ({ image }) => {
  return (
    <Carousel id="main-carousel" className="position-absolute w-100 z-n1 d-flex">
      <CarouselItem>
        <CarouselImage image={image ? image : dron1} alt={"rio"} />
      </CarouselItem>
      {/* <CarouselItem>
        <CarouselImage image={barco} alt={"barco"} />
      </CarouselItem>
      <CarouselItem>
        <CarouselImage image={kayak} alt={"kayak"} />
      </CarouselItem> */}
    </Carousel>
  );
};

export default CarouselComponent;
